import { ApolloProvider } from '@apollo/client'
import { flattenRoutes } from 'admin-web-utils'
import React, { useMemo } from 'react'
import { Route, Routes } from 'react-router'
import { RouteRedirect } from '../../components/RouteRedirect'
import { buildProjectRoutes } from '../../routes'
import { useAppContext } from '../App'
import { useConsoleContext } from '../Console'
import { useProjectContext } from './ProjectContext'
import { getProjectRoutesRoot } from './routes'

export const Project: React.FC = () => {
  const { featureFlags } = useAppContext()
  const { me, navProject, remotes } = useConsoleContext()
  const { projectClient, services } = useProjectContext()

  const projectRoutes = useMemo(() => {
    if (!navProject?.id) return []

    const routes = getProjectRoutesRoot(remotes, {
      projectId: navProject.id,
      authGroups: me.authGroups,
      featureFlags,
      serviceIds: services.map((s) => s.id),
    })

    // Flatten routes and sub routes into one array.
    // We need to filter out remote routes to not render the definition as a Route here
    // since the sub app will contain those Route(s). We only need to render the top level
    // Route that contains the SubAppContainer, hence filtering the remotes out before flattening.
    const routesWithRemotes = routes.filter((route) => route.remoteUrl)
    const routesWithoutRemotes = routes.filter((route) => !route.remoteUrl)
    const flattenedRoutesWithoutRemotes = flattenRoutes(routesWithoutRemotes)

    return [...routesWithRemotes, ...flattenedRoutesWithoutRemotes]
  }, [remotes, navProject?.id, me.authGroups, featureFlags, services])

  return (
    <ApolloProvider client={projectClient}>
      <Routes>
        <Route index element={<RouteRedirect routePath="overview" />} />
        {buildProjectRoutes({
          routes: projectRoutes,
          authGroups: me.authGroups,
          projectId: navProject?.id,
          services,
        })}
      </Routes>
    </ApolloProvider>
  )
}
